import { configVars } from 'src/helpers/configVars';

export const getCompanySettingsLink = (companyId?: string): string | null => {
  if (!companyId) return null;
  return `${configVars.settings_service_url}/companies/${encodeURIComponent(companyId)}/settings`;
};
